import React from 'react';

import Skeleton from '@smart-tv/components/skeleton';

import styles from '../episode-selector.module.scss';

export const SheetEpisodeSelectorDetailSkeleton: React.FC = () => (
  <div className={styles['episode-detail']} aria-label="Indlæser episode">
    <div className={styles['episode-detail__read-more']}>
      <Skeleton
        animation="wave"
        variant="rect"
        className={styles['episode-detail-skeleton__button']}
      />
    </div>
    <div className={styles['episode-detail__content']}>
      <Skeleton
        animation="wave"
        variant="text"
        className={styles['episode-detail-skeleton__meta']}
      />
      <div className={styles['episode-detail-skeleton__lines']}>
        <Skeleton
          animation="wave"
          variant="text"
          className={styles['episode-detail-skeleton__line--full']}
        />
        <Skeleton
          animation="wave"
          variant="text"
          className={styles['episode-detail-skeleton__line--wide']}
        />
        <Skeleton
          animation="wave"
          variant="text"
          className={styles['episode-detail-skeleton__line--short']}
        />
      </div>
    </div>
  </div>
);

SheetEpisodeSelectorDetailSkeleton.displayName = 'SheetEpisodeSelectorDetailSkeleton';

export default React.memo(SheetEpisodeSelectorDetailSkeleton);
